module.exports = __webpack_public_path__ + "img/2.ff97bcc3.png";